import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d42539ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caption-wrapper flex" }
const _hoisted_2 = { class: "caption" }

import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Caption',
  props: {
    caption: null,
    tooltip: null,
    withFormattedText: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.caption), 1),
    (__props.tooltip)
      ? (_openBlock(), _createBlock(TooltipIcon, { key: 0 }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "tooltip", {}, () => [
              _createTextVNode(_toDisplayString(__props.tooltip), 1)
            ])
          ]),
          _: 3
        }))
      : (__props.withFormattedText)
        ? (_openBlock(), _createBlock(TooltipIcon, {
            key: 1,
            inline: ""
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
  ]))
}
}

})